import React, {
    FC,
    useState,
} from "react";
import {
    Box,
    Card,
    Menu,
    MenuItem,
    Typography,
} from "@mui/material";
import {
    ArrowDropDown,
    ViewList,
    ViewModule,
} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {ViewTableStyle} from "../../enums/ViewTableStyle";

interface IButtonTableView {
    viewStyle: ViewTableStyle;
    setViewStyle: (view: ViewTableStyle) => void;
    isSmallScreen?: boolean;
    filters?: JSX.Element;

}

export const ButtonTableView: FC<IButtonTableView> = ({viewStyle, setViewStyle, filters, isSmallScreen}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeView = (view: ViewTableStyle) => {
        setViewStyle(view);
        localStorage.setItem("viewStyle", JSON.stringify(view));
        handleClose();
    };

    const mobileView =
        <Box
            onClick={handleClick}
            sx={{
                display: "flex",
                alignItems: "center",
                color: theme => theme.palette.button.primary,
            }}
        >
            {viewStyle === ViewTableStyle.GRID ? (
                <ViewModule
                    fontSize="small"
                    sx={{color: theme => theme.palette.button.primary}}
                />

            ) : (
                <ViewList
                    fontSize="small"
                    sx={{color: theme => theme.palette.button.primary}}
                />
            )}
        </Box>;

    const desktopView =
        <Box
            onClick={handleClick}
            sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "6px 12px",
                borderRadius: "4px",
                backgroundColor: theme => theme.palette.button.primary,
                "&:hover": {
                    backgroundColor: theme => theme.palette.button.hover,
                },
                transition: "background-color 0.2s",
            }}
        >
            {viewStyle === ViewTableStyle.GRID ? (
                <ViewModule fontSize="small" sx={{marginRight: 1, color: theme => theme.palette.button.text}}/>
            ) : (
                <ViewList fontSize="small" sx={{marginRight: 1, color: theme => theme.palette.button.text}}/>
            )}
            <Typography
                variant="body2"
                sx={{fontWeight: 500, color: theme => theme.palette.button.text, marginRight: "4px"}}
            >
                {viewStyle === ViewTableStyle.GRID ? <Locale localeId={IdlocaGeneric.grid}/> :
                    <Locale localeId={IdlocaGeneric.list}/>}
            </Typography>
            <ArrowDropDown
                sx={{
                    transition: "transform 0.2s",
                    transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                    color: theme => theme.palette.button.text,
                }}
            />
        </Box>;

    return (
        <Card
            sx={{
                padding: 1,
                mb: 2,
                display: "flex",
                justifyContent: filters ? "space-between" : "end",
                alignItems: "center",
                backgroundColor: theme => theme.palette.card.background,
            }}
        >
            {filters}
            {isSmallScreen ? mobileView : desktopView}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: 150,
                        backgroundColor: theme => theme.palette.card.background,
                        borderRadius: 1,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    },
                }}
            >
                <MenuItem onClick={() => changeView(ViewTableStyle.LIST)}>
                    <Locale localeId={IdlocaGeneric.list}/>
                    <ViewList fontSize="small" sx={{marginLeft: 1}}/>
                </MenuItem>
                <MenuItem onClick={() => changeView(ViewTableStyle.GRID)}>
                    <Locale localeId={IdlocaGeneric.grid}/>
                    <ViewModule fontSize="small" sx={{marginLeft: 1}}/>
                </MenuItem>
            </Menu>
        </Card>
    );
};
